export default __webpack_public_path__ + "static/media/weatherforecast.16d6c0e0.png";